import { Oval } from "react-loader-spinner";

const LoadingSpinner = () => (
  <div className="grid w-full place-content-center text-center">
    <Oval
      height={80}
      width={80}
      color="#F49038"
      secondaryColor="#FDE9D8"
      visible={true}
      ariaLabel="oval-loading"
      strokeWidth={2}
      strokeWidthSecondary={2}
    />
  </div>
);

export default LoadingSpinner;
